
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Foilceiling() {



  const cardData =
  {
    keyword: 'Foil Ceiling Work Services',
    heading: 'Anjali Enterprises: Foil Ceiling Work Services ',
    headingDescription: 'Anjali Enterprises specializes in high-quality foil ceiling installation services in Pune, offering modern and elegant ceiling solutions for both residential and commercial spaces. Whether you want a sleek, decorative design or a functional false ceiling, our team ensures precision, durability, and aesthetics in every project.',

    topPlaces: [
        {
          title: "Foil Ceiling Installation",
          description: "We provide expert foil ceiling installation services that transform the look and feel of any room. Our installations are designed to enhance both the functionality and the visual appeal of your space."
        },
        {
          title: "Decorative Foil Ceiling Services",
          description: "Our decorative foil ceiling services bring a touch of sophistication to your interiors. Using premium materials and expert techniques, we create visually stunning ceilings that elevate your home's or office's aesthetic."
        },
        {
          title: "False Ceiling Work in Pune",
          description: "Anjali Enterprises offers top-notch false ceiling work for both residential and commercial properties in Pune. Our false ceilings not only improve the appearance of your space but also provide additional benefits like insulation, lighting, and soundproofing."
        },
        {
          title: "Custom Ceiling Design",
          description: "We specialize in creating custom ceiling designs tailored to your unique preferences. Whether you’re looking for modern, traditional, or artistic designs, our team works closely with you to bring your vision to life."
        },
        {
          title: "Ceiling Panels Installation",
          description: "Our ceiling panel installation services are ideal for creating sleek and professional ceiling finishes. We offer a variety of panel options, including foil finishes, to suit your style and functional requirements."
        },
        {
          title: "Modern Ceiling Solutions",
          description: "Stay ahead with our modern ceiling solutions, designed to enhance the beauty and functionality of your space. Our foil ceilings are a perfect blend of style and practicality, making them ideal for contemporary interiors."
        },
        {
          title: "Foil False Ceilings for Commercial Spaces",
          description: "We provide foil false ceilings designed specifically for commercial spaces. Whether you're upgrading your office, retail store, or other business premises, our ceiling solutions combine style with durability."
        },
        {
          title: "Ceiling Design and Fabrication",
          description: "From conceptualization to fabrication, we offer comprehensive ceiling design and fabrication services. Our team ensures the final product aligns with your space's aesthetic and functional needs."
        },
        {
          title: "High-Quality Foil Ceiling Contractors",
          description: "As leading foil ceiling contractors in Pune, Anjali Enterprises delivers impeccable craftsmanship and high-quality materials. We focus on customer satisfaction, providing durable and aesthetically pleasing ceilings."
        },
        {
          title: "Foil Ceiling Installation in Homes and Offices",
          description: "Whether for your home or office, we provide foil ceiling installation services that enhance the overall look and feel of the space. Our team ensures timely and efficient installation, with minimal disruption to your daily activities."
        },
        {
          title: "Anjali Enterprises Contact Number",
          description: "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality foil ceiling work. We specialize in providing durable, aesthetic, and modern foil ceiling solutions for both residential and commercial spaces, enhancing the look of your interiors while offering excellent functionality. Get in touch for expert installation and professional service. Serving Pune with top-notch foil ceiling work tailored to your specific needs."
        }
      ],
      tableData: [
        ["- Foil ceiling installation", "- Decorative foil ceiling services"],
        ["- False ceiling work in Pune", "- Custom ceiling design"],
        ["- Ceiling panels installation", "- Modern ceiling solutions"],
        ["- Foil false ceilings for commercial spaces", "- Ceiling design and fabrication"],
        ["- High-quality foil ceiling contractors", "- Foil ceiling installation in homes and offices"],
        ["- Contact Anjali Enterprises for expert service"]
      ],


    "whychoose": [
  {
    "WhyChooseheading": "Expert Foil Ceiling Installation",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing high-quality foil ceiling installations for both residential and commercial spaces. Our expert team is well-versed in the latest installation techniques, ensuring a flawless finish that enhances the overall aesthetic of your space. Whether you're looking to add a sleek, modern touch to your living room, or a luxurious ambiance to your office, we offer tailored solutions that perfectly suit your needs, style, and budget."
  },
  {
    "WhyChooseheading": "Durable and Aesthetic Solution",
    "WhyChoosedescription": "Foil ceilings not only elevate the visual appeal of your space, but they are also built to last. Known for their exceptional resistance to moisture, heat, and wear, foil ceilings are ideal for spaces like kitchens and bathrooms, where functionality is just as important as beauty. Our foil ceiling installations offer both long-lasting durability and a refined aesthetic, giving you the best of both worlds in terms of both form and function."
  },
  {
    "WhyChooseheading": "Variety of Designs and Styles",
    "WhyChoosedescription": "At Anjali Enterprises, we offer a wide selection of foil ceiling designs and finishes to complement any interior. From classic smooth panels to intricate embossed designs, our collection includes glossy, matte, and textured finishes that allow you to create a personalized look. No matter the style of your home or office, we provide versatile options that cater to diverse tastes and preferences, making it easy to match your ceiling to your overall décor."
  },
  {
    "WhyChooseheading": "Quick and Efficient Installation",
    "WhyChoosedescription": "We understand that disruptions during installation can be inconvenient, which is why we prioritize quick and efficient foil ceiling installation services. Our skilled team works diligently to complete each project with minimal disruption to your daily routine. We are committed to delivering high-quality results on time, ensuring that your space is transformed as quickly as possible while maintaining the highest standards of craftsmanship and attention to detail."
  },
  {
    "WhyChooseheading": "Customizable Options",
    "WhyChoosedescription": "We recognize that every space is unique, and we provide customizable foil ceiling solutions to meet your specific needs. Whether you're working with an unusually shaped room or have a specific design in mind, our team can adapt and tailor the installation to suit the dimensions, layout, and aesthetic of your space. From bespoke patterns to personalized finishes, we ensure your foil ceiling is one-of-a-kind, reflecting your style and preferences."
  },
  {
    "WhyChooseheading": "Eco-Friendly and Safe",
    "WhyChoosedescription": "At Anjali Enterprises, we are committed to using eco-friendly materials that promote sustainability. Our foil ceiling installations utilize non-toxic, safe materials that contribute to a healthier indoor environment. By choosing our services, you're not only investing in an aesthetically pleasing and durable ceiling but also in a solution that is both safe for your family and the environment. We prioritize your well-being by ensuring that the materials we use are free from harmful chemicals and pollutants."
  },
  {
    "WhyChooseheading": "Cost-Effective",
    "WhyChoosedescription": "Foil ceiling installations provide a cost-effective alternative to traditional ceiling treatments, offering superior results at a more affordable price. We understand the importance of staying within budget, and we offer competitive pricing without compromising on quality. Our transparent pricing ensures you know exactly what to expect, and we provide detailed estimates upfront to help you make informed decisions. With our services, you can achieve a stunning ceiling without breaking the bank."
  },
  {
    "WhyChooseheading": "Long-Lasting and Low Maintenance",
    "WhyChoosedescription": "Foil ceilings are designed to be low-maintenance and easy to maintain over the years. They are resistant to dust, stains, and other common wear and tear, ensuring they stay looking new with minimal effort. A simple wipe-down is all that’s needed to keep your foil ceiling pristine, making it a practical and hassle-free solution for busy households or commercial spaces. Enjoy the beauty of your ceiling for years to come without the need for costly upkeep or frequent repairs."
  },
  {
    "WhyChooseheading": "Innovative Solutions for Every Space",
    "WhyChoosedescription": "Whether you are transforming a contemporary office, creating a stylish living room, or enhancing the décor of a commercial establishment, our foil ceiling installations bring a touch of sophistication and elegance to any environment. We offer innovative solutions that suit a variety of design themes, from modern minimalism to more intricate, decorative ceilings. Our foil ceilings elevate the atmosphere of any space, combining modern technology with timeless style to create a standout feature."
  }
]


  }

  const faqData = [
    {
      "question": "What is foil ceiling work?",
      "answer": "Foil ceiling work involves the installation of metallic or reflective foil panels as ceiling coverings. These panels can create a glossy or matte finish and are known for their durability, heat resistance, and modern appearance."
    },
    {
      "question": "How long does the installation of foil ceilings take?",
      "answer": "The installation time depends on the size of the space and the complexity of the design. Typically, our team completes foil ceiling work quickly, with minimal disruption to your daily activities, ensuring a smooth and efficient process."
    },
    {
      "question": "Can foil ceilings be installed in any room?",
      "answer": "Yes, foil ceilings can be installed in any room, including kitchens, bathrooms, living rooms, and offices. They are especially ideal for areas with high humidity or heat as they are moisture-resistant and durable."
    },
    {
      "question": "Are foil ceilings easy to maintain?",
      "answer": "Yes, foil ceilings are very low-maintenance. They resist dust and stains, and a quick wipe with a damp cloth is usually enough to keep them looking fresh and shiny. They do not require regular repainting like traditional ceilings."
    },
    {
      "question": "How do I choose the right foil ceiling design?",
      "answer": "We offer a variety of design options, including smooth, textured, or patterned finishes. Our design consultants will help you choose the right foil ceiling style that complements the aesthetics of your space and matches your personal preferences."
    },
    {
      "question": "Is foil ceiling work expensive?",
      "answer": "Foil ceiling work is generally a cost-effective alternative to other ceiling finishing options. We offer competitive pricing and will provide a clear and detailed estimate based on the scope of the project, ensuring transparency and affordability."
    },
    {
      "question": "How do I ensure that my foil ceiling installation is done correctly?",
      "answer": "Our team at Anjali Enterprises consists of experienced professionals who are experts in foil ceiling installation. We ensure that the work is completed to the highest standards, from proper measurements to precise installation and finishing."
    },
    {
      "question": "Is foil ceiling work suitable for commercial spaces?",
      "answer": "Absolutely! Foil ceilings are a popular choice for commercial spaces due to their sleek appearance, durability, and low maintenance. They add a modern touch to office buildings, retail shops, and other commercial establishments."
    },
    {
      "question": "Can foil ceilings be installed in high-ceilinged areas?",
      "answer": "Yes, foil ceilings can be installed in high-ceiling areas as well. We use the latest techniques and tools to ensure proper installation, even in difficult-to-reach or large spaces."
    },
    {
      "question": "Why should I choose Anjali Enterprises for foil ceiling work?",
      "answer": "Anjali Enterprises is committed to providing top-quality foil ceiling solutions with expert installation and excellent customer service. We offer a wide range of designs, eco-friendly materials, and affordable pricing to ensure your satisfaction with every project."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Kiran Rao",
      "text": "We decided to go with foil ceiling work for our living room, and the result is stunning. The installation team from Anjali Enterprises was professional, efficient, and paid attention to every detail. The finish is beautiful, and the room now looks more spacious and modern. Highly recommend their services!"
    },
    {
      "name": "Ms. Priya Soni",
      "text": "I hired Anjali Enterprises for foil ceiling installation in my office, and the transformation is amazing. The team was on time, and the installation was completed without any hassle. The new ceiling adds a touch of class to our workspace!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title> Foil Ceiling Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers foil ceiling installation, decorative foil ceiling services, false ceiling work, custom ceiling design, and more in Pune. Call +91 8793220265 for expert foil ceiling solutions for homes and offices." />
  <meta name="keywords" content="Foil Ceiling Installation, Decorative Foil Ceiling Services, False Ceiling Work Pune, Custom Ceiling Design, Ceiling Panels Installation, Modern Ceiling Solutions, Foil False Ceilings for Commercial Spaces, Ceiling Design and Fabrication, High-Quality Foil Ceiling Contractors, Foil Ceiling Installation in Homes and Offices" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Foil Ceiling Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers foil ceiling installation, decorative foil ceiling services, false ceiling work, custom ceiling design, and more in Pune. Call +91 8793220265 for expert foil ceiling solutions for homes and offices." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/foil-ceiling-work-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/foil-ceiling-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers foil ceiling installation, decorative foil ceiling services, false ceiling work, custom ceiling design, and more in Pune. Call +91 8793220265 for expert foil ceiling solutions for homes and offices.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/foil-ceiling-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/foil-ceiling-work-service.jpg",
        "priceRange": "₹5000 - ₹20000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/foil-ceiling-services",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "30"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ankit D"
            },
            "datePublished": "2024-06-10",
            "reviewBody": "We hired Anjali Enterprises for installing a foil ceiling in our office, and the results were amazing. The team was professional, and the ceiling design was exactly what we envisioned!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha S"
            },
            "datePublished": "2024-08-15",
            "reviewBody": "Anjali Enterprises did a fantastic job with our home’s decorative foil ceiling. It added an elegant touch to the room, and the installation was quick and clean."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/foil-ceiling-services"
        },
        "keywords": "Foil Ceiling Installation, Decorative Foil Ceiling Services, False Ceiling Work Pune, Custom Ceiling Design, Ceiling Panels Installation, Modern Ceiling Solutions, Foil False Ceilings for Commercial Spaces, Ceiling Design and Fabrication, High-Quality Foil Ceiling Contractors, Foil Ceiling Installation in Homes and Offices"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/20.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Foilceiling;